import {PAGES_CONFIG} from './pages.constants';
import {UserRoles} from './user-roles.constant';

export interface NavigationItem {
  value: string;
  route: string;
  permissions?: string[];
  excludePermissions?: string[];
}

export const NAV_MENU: Array<NavigationItem> = [
  {
    value: 'dashboard',
    route: PAGES_CONFIG.DASHBOARD
  },
  {
    value: 'requests',
    route: PAGES_CONFIG.REQUESTS,
  },
  {
    value: 'reports',
    route: PAGES_CONFIG.REPORTS,
  },
  {
    value: 'approvals',
    route: PAGES_CONFIG.APPROVALS,
    permissions: UserRoles.APP.APPROVER
  },
  {
    value: 'help',
    route: PAGES_CONFIG.HELP
  }
];
